<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    @keydown.esc="cancel"
    persistent
  >
    <v-card>
      <v-card-title>
        <v-row>
          <v-col cols="10">
            {{ title }}
          </v-col>

          <v-col class="text-right">
            <v-btn depressed icon @click="cancel">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-col cols="auto">
          <v-btn depressed height="40px" color="primary" @click.prevent="confirm()">
            Ano
          </v-btn>
        </v-col>

        <v-col cols="auto">
          <v-btn depressed height="40px" color="primary" @click="cancel">
            Ne
          </v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmationDialog',
  data() {
    return {
      dialog: false,
      title: 'Opravdu chcete akci provést?',
      questionType: '',
      options: {
        width: 600,
      },
      resolve: null,
      reject: null,
    };
  },
  methods: {
    open(questionType, options) {
      this.dialog = true;
      this.title = questionType || this.title;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    confirm() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
  },
};
</script>
